// Live Recent check-ins window is an account duty-policy value. Keep the allowlist and clamp
// outside Command map fetch so policy mapper, Platform chips, and fetchScanPoints cannot drift.

/** Lock default: accounts keep a 24-hour Live check-in window until an operator chooses otherwise. */
export const LIVE_CHECKIN_MAX_AGE_DEFAULT_HOURS = 24;

/** The only values accepted by the policy CHECK and exposed by the Platform chips. */
export const LIVE_CHECKIN_MAX_AGE_ALLOWED_HOURS = [6, 12, 24, 48, 72] as const;

export type LiveCheckinMaxAgeHours = (typeof LIVE_CHECKIN_MAX_AGE_ALLOWED_HOURS)[number];

/** Snap an arbitrary boundary value onto the allowed chips, failing safe to the default. */
export function liveCheckinMaxAgeHours(
  requested: number | null | undefined,
): LiveCheckinMaxAgeHours {
  if (typeof requested !== "number" || !Number.isFinite(requested)) {
    return LIVE_CHECKIN_MAX_AGE_DEFAULT_HOURS;
  }
  let best: LiveCheckinMaxAgeHours = LIVE_CHECKIN_MAX_AGE_DEFAULT_HOURS;
  let bestDistance = Number.POSITIVE_INFINITY;
  for (const allowed of LIVE_CHECKIN_MAX_AGE_ALLOWED_HOURS) {
    const distance = Math.abs(allowed - requested);
    if (distance < bestDistance || (distance === bestDistance && allowed < best)) {
      best = allowed;
      bestDistance = distance;
    }
  }
  return best;
}

/** ISO cutoff for PostgREST `.gte("server_received_at", cutoff)`. */
export function liveCheckinCutoffIso(maxAgeHours: LiveCheckinMaxAgeHours, nowMs: number): string {
  return new Date(nowMs - maxAgeHours * 60 * 60 * 1000).toISOString();
}
